/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import React, { Component } from "react";
import styles from "./MapContainer.module.css";
import Map from "../../components/Map/Map";
import SideDrawer from "../../components/SideDrawer/SideDrawer";
import { connect } from "react-redux";
import {
  fetchReplayCoordinates,
  setCoordinate,
  checkAuthentication,
  fetchTodaysGeometry,
  fetchVehicles,
} from "../../../store/actions";
import Websocket from "react-websocket";
import {
  filterAndUpdateCoordinates,
  makeEmptyCoordinatesArray,
  showVehicleInfoToast,
  isContainsCoordinatesInViewPort,
} from "../../../shared/vehicles";
import filter from "lodash/filter";
import { toast } from "react-toastify";
import Backdrop from "../../components/Backdrop/Backdrop";
import Greeting from "../../../Greeting/Greeting";
import { scroller } from "react-scroll";
import { constant } from "./../../../shared/constants/constants";
import IdleTimer from "react-idle-timer";

const TIMEOUT_TIME = 600000;

class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedVehicle: {
        id: "",
        key: "",
        lat: 33.81486511230469,
        lng: -117.85834503173828,
      },
      selectedVehicleHistory: {
        id: null,
        key: null,
        userName: null,
        vehicleName: null,
        status: "",
        lastUpdated: "",
      },
      isVehicleDetailsVisible: false,
      liveCoordinates: [],
      displayCoordinates: [],
      isPaused: true,
      isWebsocketOn: true,
      isSideDrawerVisible: true,
    };
    this.vehicleLocations = null;
    this.tracks = [];
    this.counter = 0;
    this.currentPortCenter = {
      lat: null,
      lng: null,
    };
    this.centerDecider = false;
    this.interval = null;
    this.counter = 0;
    this.intervalTime = 1000;
    this.replayLatLng = [];
    this.idleTimer = React.createRef();
  }

  // used to avoid unnecessary renders
  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.isVehicleDetailsVisible) {
      if (this.state.liveCoordinates !== nextState.liveCoordinates)
        return false;
    }
    return true;
  }

  // called when component mounted
  componentDidMount() {
    let params = new URLSearchParams(window.location.search);
    const mode = params.get("mode");
    // set the auth data in redux store
    this.props.checkAuthentication();
    if (mode === "createProperty")
      this.setState({ isSideDrawerVisible: false });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.usersVehiclesInfo) {
      if (
        this.props.usersVehiclesInfo.vehicles.length !==
        prevProps.usersVehiclesInfo.vehicles.length
      ) {
        showVehicleInfoToast(this.props.usersVehiclesInfo);
        this.setState({
          liveCoordinates: makeEmptyCoordinatesArray(
            this.props.usersVehiclesInfo.vehicles
          ),
        });
      }
    }

    if (
      this.props.replayCoordinates.length !== prevProps.replayCoordinates.length
    ) {
      this.replayLatLng = this.props.replayCoordinates.map((o) => {
        return {
          lat: o.latitude,
          lng: o.longitude,
        };
      });
    }

    if (this.props.accountId !== prevProps.accountId) {
      if (this.props.accountId) {
        this.props.fetchTodaysGeometry();
        this.props.fetchVehicles();
      }
    }
  }

  // toggle visibility of side drawer
  toggleSideDrawer = () => {
    this.setState({ isSideDrawerVisible: !this.state.isSideDrawerVisible });
  };

  // select vehicle handler either by clicking card or bus
  vehicleSelectionHandler = (key, id, type) => {
    let selectedItem =
      filter(this.state.liveCoordinates, (o) => o.key === key) || [];

    // set the selected vehicle in map center
    let lat = 33.81486511230469;
    let lng = -117.85834503173828;
    if (selectedItem.length < 1 || selectedItem[0].pos.length < 1) {
      this.centerDecider = false;
    } else {
      this.centerDecider = true;
      lat = selectedItem[0].pos[selectedItem[0].pos.length - 1].lat;
      lng = selectedItem[0].pos[selectedItem[0].pos.length - 1].lng;
    }

    // scroll the selected vehicle card to up
    if (type === "marker") {
      scroller.scrollTo(key, {
        duration: 800,
        delay: 0,
        smooth: "easeInOutQuart",
        containerId: "scroll-container",
        offset: -65,
      });
    }

    // set the selected vehicles info in state
    const updatedSelectedVehicle = {
      ...this.state.selectedVehicle,
      id: id,
      key: key,
      lat: lat,
      lng: lng,
    };
    this.setZoom(18);
    this.setState({ selectedVehicle: updatedSelectedVehicle });
  };

  // set dynamic zoom in map
  setZoom = (zoom) => {
    global.mapRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.setZoom(
      zoom
    );
  };

  // handle websocket incoming live coordinates data
  handleData = (data) => {
    let updatedCoordinates = filterAndUpdateCoordinates(
      this.props.usersVehiclesInfo.pairedUsers,
      JSON.parse(data),
      this.state.liveCoordinates
    );
        this.setState({ liveCoordinates: updatedCoordinates });
  };

  // handle dynamic map center changes
  centerChangeHandler = () => {
    // move the map center according to replay vehicle movement
    if (this.state.isVehicleDetailsVisible) {
      if (this.props.replayCoordinates.length > 0) {
        if (isContainsCoordinatesInViewPort(this.replayLatLng)) {
          this.centerDecider = false;
        } else {
          this.centerDecider = true;
        }
      }
    }
    if (!this.state.isVehicleDetailsVisible) {
      this.centerDecider = false;
    }
    this.currentPortCenter.lat = global.mapRef.getCenter().lat();
    this.currentPortCenter.lng = global.mapRef.getCenter().lng();
  };

  // show vehicle details / replay side drawer
  vehicleDetailHandler = (
    key,
    id,
    userName,
    vehicleName,
    status,
    lastUpdated,
    vehicleId,
    userId
  ) => {
    const updatedVehicleDetail = {
      ...this.state.selectedVehicleHistory,
      id: id,
      key: key,
      userName: userName ? userName : null,
      vehicleName: vehicleName ? vehicleName : null,
      status: status,
      lastUpdated: lastUpdated,
    };
    this.centerDecider = true;
    this.setZoom(18);
    this.setState({
      selectedVehicleHistory: updatedVehicleDetail,
      isVehicleDetailsVisible: true,
    });
  };

  // close vehicle detail/ replay side drawer
  closeVehicleDetailDrawer = () => {
    // reset all the values in state
    const updatedVehicleDetail = {
      ...this.state.selectedVehicleHistory,
      id: null,
      key: null,
      userName: null,
      vehicleName: null,
      status: "",
      lastUpdated: "",
    };
    this.centerDecider = false;
    this.setZoom(10);
    this.setState({
      selectedVehicleHistory: updatedVehicleDetail,
      isVehicleDetailsVisible: false,
      displayCoordinates: [],
      isPaused: true,
    });
    // clear previously fetched replay coordinates data
    this.props.setReplayCoordinate([]);
  };

  // play replay vehicle
  playTrack = () => {
    if (this.props.replayCoordinates.length < 1) return;
    this.centerDecider = true;
    if (this.counter >= this.props.replayCoordinates.length) {
      toast.info(constant.NO_MORE_PATH);
      return;
    }
    this.interval = setInterval(this.vehicleTrackHandler, this.intervalTime);
  };

  // helper method to move the replay vehicle
  vehicleTrackHandler = () => {
    if (this.props.replayCoordinates.length < 1) return;
    if (this.counter >= this.props.replayCoordinates.length) return;

    const updatedDisplayCoordinates = [...this.state.displayCoordinates];
    updatedDisplayCoordinates.push(this.props.replayCoordinates[this.counter]);

    this.setState(
      { displayCoordinates: updatedDisplayCoordinates, isPaused: false },
      () => {
        this.counter++;
      }
    );
  };

  // pause the replay vehicle movement
  pauseTrack = () => {
    if (this.props.replayCoordinates.length < 1) return;
    this.setState({ isPaused: true });
    clearInterval(this.interval);
  };

  // reset the replay vehicle position (brings it to the starting point)
  resetTrack = () => {
    if (this.props.replayCoordinates.length < 1) return;
    this.counter = 0;
    clearInterval(this.interval);

    const updatedDisplayCoordinates = [];
    updatedDisplayCoordinates.push(this.props.replayCoordinates[this.counter]);

    this.setState({ displayCoordinates: updatedDisplayCoordinates }, () => {
      this.counter++;
    });
  };

  // forward replay vehicle by coordinates
  forwardTrack = (seconds) => {
    if (this.props.replayCoordinates.length < 1) return;

    // if no more path to show toast
    if (this.counter >= this.props.replayCoordinates.length) {
      toast.info(constant.NO_MORE_PATH);
      return;
    }

    // pause the track
    this.pauseTrack();

    // coordinates to add
    let itemsToAdd = seconds / (this.intervalTime / 1000);
    const updatedDisplayCoordinates = [...this.state.displayCoordinates];
    while (this.counter < this.props.replayCoordinates.length && itemsToAdd) {
      updatedDisplayCoordinates.push(
        this.props.replayCoordinates[this.counter]
      );
      this.counter++;
      itemsToAdd--;
    }
    this.setState({ displayCoordinates: updatedDisplayCoordinates });
  };

  // backward replay vehicle
  backwardTrack = (seconds) => {
    if (this.props.replayCoordinates.length < 1) return;

    // if no more path to show toast
    if (this.counter <= 1) {
      toast.info(constant.STARTING_POINT);
      return;
    }
    // pause track
    this.pauseTrack();

    // coordinates to remove
    let itemsToRemove = seconds / (this.intervalTime / 1000);
    const updatedDisplayCoordinates = [...this.state.displayCoordinates];
    updatedDisplayCoordinates.splice(itemsToRemove * -1, itemsToRemove);
    if (updatedDisplayCoordinates.length === 0) {
      this.resetTrack();
      return;
    }
    this.counter -= itemsToRemove;

    this.setState({ displayCoordinates: updatedDisplayCoordinates });
  };

  // plot whole replay vehicle path
  plotWholeTrack = () => {
    if (this.props.replayCoordinates.length < 1) return;
    clearInterval(this.interval);
    const updatedDisplayCoordinates = [];
    for (let r of this.props.replayCoordinates)
      updatedDisplayCoordinates.push(r);
    this.setState({ displayCoordinates: updatedDisplayCoordinates });
    this.counter = this.props.replayCoordinates.length;
  };

  // fetch selected vehicle replay coordinates
  replaySubmitHandler = (startDateTime, endDateTime, equipmentId) => {
    this.counter = 0;

    // stop if already a vehicle is moving
    clearInterval(this.interval);
    this.setState({ displayCoordinates: [], isPaused: true });

    this.props.fetchReplayCoordinates(startDateTime, endDateTime, equipmentId);
  };

  // stop websocket when user is idle for 10 minutes
  websocketStatusHandler = () => {
    if (!this.state.isWebsocketOn) {
      window.location.reload();
      return;
    }
    this.setState({ isWebsocketOn: !this.state.isWebsocketOn });
  };

  // show refresh button when user is idle for 10 minutes
  handleOnIdle = (event) => {
    let timer = this.idleTimer.current;
    if (timer.isIdle() && timer.getRemainingTime() == 0) {
      this.websocketStatusHandler();
      timer.pause();
    }
  };

  render() {
    let detailLat = null;
    let detailLng = null;
    let replayTimeStamp = null;
    if (this.state.displayCoordinates.length > 0) {
      let len = this.state.displayCoordinates.length;
      detailLat = this.state.displayCoordinates[len - 1].latitude;
      detailLng = this.state.displayCoordinates[len - 1].longitude;
      replayTimeStamp =
        this.state.displayCoordinates[this.state.displayCoordinates.length - 1]
          .Timestamp;
    }
            
    return (
      <div>
        <Backdrop
          clicked={this.websocketStatusHandler}
          show={!this.state.isWebsocketOn}
        />
        <div
          className={styles.MapCont}
          className={
            this.state.isSideDrawerVisible
              ? styles.AdjustedView
              : styles.FullView
          }>
          <Map
            centerChanged={this.centerChangeHandler}
            coordinates={this.state.liveCoordinates}
            selectedVehicle={this.state.selectedVehicle}
            selectVehicle={this.vehicleSelectionHandler}
            viewportCenter={this.currentPortCenter}
            centerDecider={this.centerDecider}
            isVehicleDetailsVisible={this.state.isVehicleDetailsVisible}
            replayCoordinates={this.state.displayCoordinates}
            detailCenterCoordinates={{ detailLat, detailLng }}
          />
        </div>
        <div>
          <SideDrawer
            toggleSideDrawer={this.toggleSideDrawer}
            isSideDrawerVisible={this.state.isSideDrawerVisible}
            selectedVehicle={this.state.selectedVehicle}
            vehicleSelect={this.vehicleSelectionHandler}
            coordinates={this.state.liveCoordinates}
            vehicleDetailHandler={this.vehicleDetailHandler}
            isVehicleDetailsVisible={this.state.isVehicleDetailsVisible}
            closeVehicleDetailDrawer={this.closeVehicleDetailDrawer}
            selectedVehicleHistory={this.state.selectedVehicleHistory}
            pauseTrack={this.pauseTrack}
            playTrack={this.playTrack}
            resetTrack={this.resetTrack}
            forwardTrack={this.forwardTrack}
            backwardTrack={this.backwardTrack}
            isPausedTrack={this.state.isPaused}
            plotWholeTrack={this.plotWholeTrack}
            replaySubmitHandler={this.replaySubmitHandler}
            replayTimeStamp={replayTimeStamp}
            showReplayControls={this.props.replayCoordinates.length > 0}
            initialReplayTimestamp={
              this.props.replayCoordinates.length > 0
                ? this.props.replayCoordinates[0].Timestamp
                : null
            }
            visitsInfo={this.props.visitsInfo}
          />
        </div>

        {this.state.isWebsocketOn && this.props.accountId && (
          <Websocket
            url={`${process.env.REACT_APP_WEBSOCKET_URL}?subscriberId=${this.props.accountId}`}
            onMessage={this.handleData}
          />
        )}

        <IdleTimer
          ref={this.idleTimer}
          timeout={TIMEOUT_TIME}
          onIdle={this.handleOnIdle}
          debounce={250}
        />
        <Greeting switchPath="geofence" />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usersVehiclesInfo: state.vehicle.usersVehiclesInfo,
    replayCoordinates: state.coordinates.replayCoordinates,
    visitsInfo: state.visit.visitsInfo,
    accountId: state.auth.accountId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchReplayCoordinates: (startDateTime, endDateTime, equipmentId) =>
      dispatch(fetchReplayCoordinates(startDateTime, endDateTime, equipmentId)),
    setReplayCoordinate: (emptyArray) => dispatch(setCoordinate(emptyArray)),
    checkAuthentication: () => dispatch(checkAuthentication()),
    fetchVehicles: () => dispatch(fetchVehicles()),
    fetchTodaysGeometry: () => dispatch(fetchTodaysGeometry()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MapContainer);
